import React from "react"
import { IViewModeToggle } from "./model"
import "./style.scss"

/**
 * Generic Checkbox for use through out all applications.
 */
export function ViewModeToggle({ style, name, className, active, labelRight, labelLeft, callback }: IViewModeToggle) {
    return (
        <div className={`vtg ${className || ""}`} style={style}>
            <label>
                <div role="vtg-label" className={`vtg-background ${active ? "active" : ""}`}>
                    <span className="labels" lbl-right={labelRight} lbl-left={labelLeft}></span>
                    <span role="slider" className="slider">
                        {active ? labelRight : labelLeft}
                    </span>
                </div>
                <input role="view-toggle" name={name} type="checkbox" checked={active} onChange={callback} />
            </label>
        </div>
    )
}
